import React from 'react';
import Text from 'components/Text';

const AutoCompleteKeycloakUserModel: React.FC = (props: any) => {
  const { item } = props;
  return (
    <>
      <Text className="text-left color-blue-gray" size={13}>
        {item.username}
      </Text>
      <Text className="text-left" size={10}>
        {`${item.firstName} ${item.lastName}`}
      </Text>
    </>
  );
};

export default AutoCompleteKeycloakUserModel;
